module.exports = __webpack_public_path__ + "img/9f455d9.png";